var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    enableBackground: "new 0 0 48 48",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00797D",
    d: "M27.885,23.921l11.329-11.313c0.875-0.876,0.875-2.296,0-3.172c-0.877-0.876-2.299-0.875-3.175,0 L21.555,23.921l14.876,14.876c0.437,0.438,1.012,0.656,1.585,0.656c0.574,0,1.148-0.219,1.586-0.656 c0.877-0.876,0.877-2.297,0.001-3.173L27.885,23.921z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#00797D",
    d: "M13.137,23.827L29.92,7.066c1.297-1.298,1.297-3.402,0-4.699c-1.299-1.298-3.404-1.297-4.7,0L3.761,23.827 l22.037,22.038c0.648,0.648,1.499,0.974,2.35,0.974s1.703-0.325,2.35-0.974c1.298-1.297,1.298-3.401,0.002-4.699L13.137,23.827z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.23700c917f4b30f67d9f12fc7224e29e.svg";
export { ForwardRef as ReactComponent };